import React, { Component } from "react";
import { BrowserRouter, withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {ThemeProvider} from '@material-ui/core/styles';
import Header from "./components/Header/Header";
import Body from "./components/Body/Body";
import Breadcrumb from "./components/Breadcrumb/Breadcrumb";
import Login from "./screens/login/LoginMain";
import AppMem from "./common/AppMem";
import Favicon from "./components/FaviconSelector";
import { Settings } from "./provider/base";
import Home from "@material-ui/icons/Home";
import User from "@material-ui/icons/PermIdentity";
import RolesIcon from "@material-ui/icons/Lock"
import Notifications from "@material-ui/icons/Notifications";
import News from "@material-ui/icons/Assignment";
import Place from "@material-ui/icons/Place"
import Statistics from '@material-ui/icons/BarChart'
import Exit from "@material-ui/icons/ExitToApp";
import {Helmet} from "react-helmet";
import Loadable from "react-loading-overlay";
import { actionVerifyLogin, actionLogOut } from "./actions/AuthActions"
import {
	INDEX_ROUTE,
  LOGIN_ROUTE,
  EVENTS_ROUTE,
  EVENTS_STATISTICS_ROUTE,
  // STATISTICS_RRPP_ROUTE,
  TICKET_TYPES_ROUTE,
  TICKETS_ROUTE,
  USERS_ROUTE,
	ROLES_ROUTE,
  PLACES_EDIT_ROUTE,
  PLACES_ROUTE,
	NOTIFICATIONS_ROUTE,
	NEWS_ROUTE,
	STATISTICS_ROUTE,
	EVENTS_STATISTICS_DIRECT_RRPP_ROUTE,
	EVENTS_STATISTICS_REFERENCED_RRPP_ROUTE,
	EVENTS_STATISTICS_PRODUCER_ROUTE,
  UNAUTHORIZED_ROUTE
} from "./config/RoutesConstants";
import Roles from "./config/RolesConstants"
import DrawerVault from "./components/DrawerVault/DrawerVault";
import DrawerGroupItem from "./components/DrawerVault/DrawerGroupItem";
import "./App.css";
import ProducerTheme from "./config/Themes"
import { validateAccess } from "./common/ValidateAccess"

class App extends Component {
	constructor(props) {
		super(props);
		this.state = { openLeftDrawer: false };
		this.Logout = this.Logout.bind(this);
		this.routes = {
      home: { name: "Home", path: INDEX_ROUTE },
      events: { name: "Eventos", path: EVENTS_ROUTE },
			ticketTypes: { name: "Tipos de Ticket", path: TICKET_TYPES_ROUTE},
			tickets: { name: "Tickets", path: TICKETS_ROUTE },
			users: { name: "Usuarios", path: USERS_ROUTE },
			roles: { name: "Roles", path: ROLES_ROUTE },
			places: { name: "Ubicaciones", path: PLACES_ROUTE },
			statistics: { name: "Estadísticas por evento", path: EVENTS_STATISTICS_ROUTE },
			// rrpp: {name:"Vendidas por RRPP", path: STATISTICS_RRPP_ROUTE },
			directRrpp: {name:"Ventas directa por RRPP", path: EVENTS_STATISTICS_DIRECT_RRPP_ROUTE },
			referencedRrpp: {name:"Ventas referidas por RRPP", path: EVENTS_STATISTICS_REFERENCED_RRPP_ROUTE },
			producer: {name:"Ventas por productor", path: EVENTS_STATISTICS_PRODUCER_ROUTE },
			notification: {name:"Notificaciones", path: NOTIFICATIONS_ROUTE },
			news: {name:"Novedades", path: NEWS_ROUTE },
			stats: {name:"Estadísticas", path: STATISTICS_ROUTE }

		}
		// this.LogoutSuccess = this.LogoutSuccess.bind(this);
	}

	toggleLeftDrawer = () =>
		this.setState({ openLeftDrawer: !this.state.openLeftDrawer });

	Logout = () => {
		this.setState({
			openLeftDrawer: !this.state.openLeftDrawer
		});
		this.props.actionLogOut();
	};

	componentWillMount(){
		this.props.actionVerifyLogin(
			()=>this.props.history.replace(LOGIN_ROUTE)
		)
	}

	getItems = () => {
		return {
			events: <DrawerGroupItem
								toLink={EVENTS_ROUTE}
								onTouchTap={this.toggleLeftDrawer}
								textoItem="Eventos"
								icon={<Home />}
								innerDivStyle={{ padding: "0px 16px 0px 53px" }}							
							/>,
			users: <DrawerGroupItem
								toLink={USERS_ROUTE}
								onTouchTap={this.toggleLeftDrawer}
								textoItem="Usuarios"
								icon={<User/>}
								innerDivStyle={{ padding: "0px 16px 0px 53px" }}
							/>,
			roles: <DrawerGroupItem
								toLink={ROLES_ROUTE}
								onTouchTap={this.toggleLeftDrawer}
								textoItem="Roles"
								icon={<RolesIcon/>}
								innerDivStyle={{ padding: "0px 16px 0px 53px" }}
							/>,
			notifications: <DrawerGroupItem
												toLink={NOTIFICATIONS_ROUTE}
												onTouchTap={this.toggleLeftDrawer}
												textoItem="Notificaciones"
												icon={<Notifications/>}
												innerDivStyle={{ padding: "0px 16px 0px 53px" }}
										/>,
			news: <DrawerGroupItem
								toLink={NEWS_ROUTE}
								onTouchTap={this.toggleLeftDrawer}
								textoItem="Novedades"
								icon={<News/>}
								innerDivStyle={{ padding: "0px 16px 0px 53px" }}
						/>,
			statistics: <DrawerGroupItem
					toLink={STATISTICS_ROUTE}
					onTouchTap={this.toggleLeftDrawer}
					textoItem="Estadísticas"
					icon={<Statistics/>}
					innerDivStyle={{ padding: "0px 16px 0px 53px" }}
			/>
		}
	}
//Productor, RRPP, Redimidor/Guardia, Default, Admin, SuperAdmin.
	addItem(items, item){
		if(!items.includes(item)){
			items.push(item)
		}
	}
	addSuperAdminItems(items, allItems){
		const all = Object.keys(allItems)
		for(let i=0;i<all.length;i++){
			this.addItem(items, allItems[all[i]])
		}
		
	}
	addAdminItems(items, allItems){
		this.addItem(items, allItems.users)
		this.addItem(items, allItems.roles)
	}
	addRedimidorItems(items, allItems){
		this.addItem(items, allItems.events)
	}
	addProductorItems(items, allItems){
		this.addItem(items, allItems.events)
		this.addItem(items, allItems.notifications)
		this.addItem(items, allItems.statistics)
	}
	addRrppItems(items, allItems){
		//this.addItem(items, allItems.) Agregar items del menú a los que puede acceder el rol Rrpp
	}
	addDefaultItems(items, allItems){
		//this.addItem(items, allItems.) Agregar items del menú a los que puede acceder el rol Default
	}
	renderItemsByRoles(roles){
		//Devolver los items a agregar según los roles.
		let items = []
		if(roles){
			console.log("ROLES", roles)
			const allItems = this.getItems()
			for(let i=0;i<roles.length;i++){
				let rol = roles[i]
				switch(rol.id){
					case Roles.SUPERADMIN: this.addSuperAdminItems(items, allItems); break;
					case Roles.ADMIN: this.addAdminItems(items, allItems); break;
					case Roles.REDIMIDOR: this.addRedimidorItems(items, allItems); break;
					case Roles.PRODUCTOR: this.addProductorItems(items, allItems); break;
					case Roles.RRPP: this.addRrppItems(items, allItems); break;
					case Roles.DEFAULT: this.addDefaultItems(items, allItems); break;
					default: console.log("ROL DESCONOCIDO", rol.id)
				}			
			}
		}
		return items
	}

	renderHeader(loggedIn, roles) {
		if (loggedIn) {
			return (
				<div>
					<Header
						leftIconClick={this.toggleLeftDrawer}
						hideDrawer={this.state.openLeftDrawer}
					/>
					<Breadcrumb
            routesInfo={this.routes}
            path={window.location.pathname}
            separatorStyle={{ color: "#1bb6b1" }}
          />
					<DrawerVault
						username={this.props.username}
						email={this.props.email}
						isOpen={this.state.openLeftDrawer}
						onRequestChangeDrawer={openLeftDrawer =>
							this.setState({ openLeftDrawer })
						}
						avatarSrc={this.props.photo||require("./common/assets/profile_icon.png")}
					>
						{this.renderItemsByRoles(roles)}
						{/* <DrawerGroupItem
							toLink={PLACES_ROUTE}
							onTouchTap={this.toggleLeftDrawer}
							textoItem="Ubicaciones"
							icon={<Place/>}
							innerDivStyle={{ padding: "0px 16px 0px 53px" }}
						/> */}
						<DrawerGroupItem
							toLink={LOGIN_ROUTE}
							onTouchTap={this.Logout}
							textoItem="Cerrar sesión"
							icon={<Exit/>}
							innerDivStyle={{ padding: "0px 16px 0px 53px" }}
						/>
					
					</DrawerVault>
				</div>
			);
		}
	}

	render() {
		const {loading, login, profile, history} = this.props
		if(login){
			const path = history.location.pathname
			const isAuthorized = path==UNAUTHORIZED_ROUTE||login&&validateAccess(profile&&profile.proRoles, path)
			console.log("HEADER", login, profile, isAuthorized, history.location.pathname)
			if(!isAuthorized){
				history.replace(UNAUTHORIZED_ROUTE)
			}
		}
		return (
			// <div style={{ height: "100%" }}>
				<ThemeProvider theme={ProducerTheme}>
					{/* <div style={{ height: "100%" }}> */}
					<Helmet>
						<link id="favicon" rel="icon" type="image/x-icon" href={Favicon} sizes="16x16" />
					</Helmet>
						<Loadable
							spinner
							active={loading}
							text="Loading..."
							style={{ height: "100%" }}
						>
							{this.renderHeader(login, profile&&profile.proRoles)}
							<Body style={ProducerTheme.routesContainer}/>
						</Loadable>
					{/* </div> */}
				</ThemeProvider>
			// </div>
		);
	}
}

function mapStateToProps(store) {
	return {
		login: store.auth.login,
		username: store.auth.username,
		email: store.auth.email,
		photo: store.auth.photo,
		profile: store.auth.profile,
		loading: store.app.loading,
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			actionLogOut,
			actionVerifyLogin
		},
		dispatch
	);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/App.js